var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @desc map chart
 */
import * as lodash from '../../utils/lodash';
import { SeriesModel } from '../../model';
import { Group } from '../../element';
import { registerChart } from '../index';
/**
 * export
 */
var MapChart = /** @class */ (function (_super) {
    __extends(MapChart, _super);
    function MapChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'map';
        return _this;
    }
    MapChart.prototype.getDefaultOption = function (option) {
        return {
            type: 'map',
            facet: 0,
            coord: 'geo',
            name: '',
            // map: '',
            // nameMap: {},
            // zooming: false,
            // panning: false,
            encode: {
                name: '',
                value: '',
                color: [(option.encode || {}).value, '#EEF1FF-#4261F6'],
            },
            shapeStyle: {
                fill: '#F0F2F6',
                stroke: '#CCD0E1',
                lineWidth: 1,
            },
            label: {
                show: false,
                fontSize: 12,
                color: '#1A1E22',
                position: 'inside',
                distance: 4,
            },
            hover: {
                shapeStyle: {
                    fill: '#FFD131',
                    stroke: null,
                    lineWidth: null,
                },
                label: {
                    show: true,
                    fontSize: 12,
                    color: '#1A1E22',
                    position: 'inside',
                    distance: 4,
                },
            },
            selected: {
                shapeStyle: {
                    fill: null,
                    stroke: null,
                    lineWidth: null,
                },
            },
            selectedMode: false,
            visible: true,
            showLegend: false,
        };
    };
    MapChart.prototype.getInitialState = function () {
        return {
            points: [],
            needAnimation: false,
        };
    };
    MapChart.prototype.init = function () {
        this._mergeMapOption();
    };
    MapChart.prototype.toggleHighlightPoint = function (dataIndex, active) {
        _super.prototype.toggleHighlightPoint.call(this, dataIndex, active);
    };
    MapChart.prototype.toggleSelectPoint = function (dataIndex, selected) {
        _super.prototype.toggleSelectPoint.call(this, dataIndex, selected);
        var point = this.state.points[dataIndex];
        var geoModel = this.chart.getComponentModel('coord').geo;
        var region = lodash.find(geoModel.getState().regions, function (item) { return item.name === point.name; });
        geoModel.toggleSelectRegion(region, selected);
    };
    MapChart.prototype.beforeRender = function () {
        var _this = this;
        var geoModel = this.chart.getComponentModel('coord').geo;
        var points = this._dataset.mapData(function (record, dataIndex) {
            var encode = _this._encode.getEncodeData(record, dataIndex);
            return {
                name: encode.name,
                value: encode.value,
                color: encode.color,
                encode: encode,
                visible: !_this.invisibleItems.has(dataIndex),
                selected: _this.selectedItems.has(record),
            };
        });
        this.setState({
            points: points,
        });
        if (this.option.coord === 'amap') {
            var amap = this.chart.getComponentModel('coord').getCordinateSystem('amap');
            amap.updateRegionsStyle(points);
        }
        else {
            geoModel.getState().regions.forEach(function (region) {
                var matchPoint = lodash.find(points, function (point) { return point.name === region.name; });
                if (matchPoint && matchPoint.visible) {
                    var dataIndex = _this.state.points.indexOf(matchPoint);
                    region.color = matchPoint.color;
                    region.data = {
                        point: _this.getWrappedPoint(dataIndex),
                    };
                    region.selected = matchPoint.selected;
                }
            });
        }
    };
    MapChart.prototype.updated = function () {
        this._mergeMapOption();
    };
    MapChart.prototype.render = function () {
        return new Group({ key: this.getKey('map') });
    };
    MapChart.prototype._mergeMapOption = function () {
        if (this.option.coord === 'amap') {
            var option = this.chart.getComponentModel('coord').getCordinateSystem('amap').getOption();
            lodash.merge(option, this.option);
        }
        else {
            var geoModel = this.chart.getComponentModel('coord').geo;
            lodash.merge(geoModel.option, this.option);
        }
    };
    MapChart.dependencies = ['coord'];
    return MapChart;
}(SeriesModel));
export default MapChart;
registerChart('map', MapChart);
